export default "__VITE_ASSET__ad6a9773__"